export const parseProductTypesOptions = data => {
  return data?.map(item => ({ value: item?.id, label: item?.name })) || [];
};

export const parseProductTypesOptionsWithRef = data => {
  return data?.map(item => ({ value: item?.crn, label: item?.name })) || [];
};
